import { render, staticRenderFns } from "./Property.vue?vue&type=template&id=528de378&scoped=true&"
import script from "./Property.vue?vue&type=script&lang=js&"
export * from "./Property.vue?vue&type=script&lang=js&"
import style0 from "./Property.vue?vue&type=style&index=0&id=528de378&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528de378",
  null
  
)

export default component.exports